import React, { useState } from 'react';
import { AccountWithUser } from 'pages/admin/Accounts';
import ModalComp from 'components/layouts/Modal';
import { NumberInput } from 'components/form/NumberInput';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import useUserStore from 'state/userStore';
import { z } from 'zod';
import Button from 'components/form/Button';
import { updateAccountById } from 'api/account';
import { toast } from 'react-toastify';
import { getNumbers } from 'helpers';

const fields = [
  {
    name: 'balance',
    type: 'text',
    label: 'Balance',
    placeholder: 'balance',
    disabled: false,
  },
  {
    name: 'profit',
    type: 'text',
    label: 'Profit',
    placeholder: 'profit',
    disabled: false,
  },
  {
    name: 'walletBalance',
    type: 'text',
    label: 'Wallet Balance',
    placeholder: 'wallet balance',
    disabled: false,
  },
  {
    name: 'investment',
    type: 'text',
    label: 'Investment',
    placeholder: 'investment',
    disabled: false,
  },
  {
    name: 'bitcoin',
    type: 'text',
    label: 'Bitcoin',
    placeholder: 'bitcoin',
    disabled: false,
  },
  {
    name: 'ethereum',
    type: 'text',
    label: 'Ethereum',
    placeholder: 'ethereum',
    disabled: false,
  },
  {
    name: 'bnb',
    type: 'text',
    label: 'BNB',
    placeholder: 'bnb',
    disabled: false,
  },
  {
    name: 'litecoin',
    type: 'text',
    label: 'Litecoin',
    placeholder: 'lietcoin',
    disabled: false,
  },
  {
    name: 'usdt',
    type: 'text',
    label: 'USDT',
    placeholder: 'usdt',
    disabled: false,
  },
];

interface AccountProps {
  data: AccountWithUser;
  closeModal: () => void;
  reload: () => void;
}

const AccountSchema = z.object({
  balance: z.string().optional(),
  walletBalance: z.string().optional(),
  profit: z.string().optional(),
  investment: z.string().optional(),
  bitcoin: z.string().optional(),
  litecoin: z.string().optional(),
  usdt: z.string().optional(),
  bnb: z.string().optional(),
});

type AccountSchemaType = z.infer<typeof AccountSchema>;

const AccountModal = ({
  data: { user: selectedUser, ...account },
  closeModal,
  reload,
}: AccountProps) => {
  const { user } = useUserStore();
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { isValid, isDirty, dirtyFields },
  } = useForm<AccountSchemaType>({
    resolver: zodResolver(AccountSchema),
    mode: 'onTouched',
    defaultValues: {
      ...account,
      profit: String(account.profit),
      investment: String(account.investment),
    },
  });

  const updateUserFunction = async (update: any) => {
    if (!user) return;

    setLoading(true);
    try {
      const res = await updateAccountById({
        userType: user.type,
        data: update,
        userId: selectedUser._id,
      });

      if (res?.data) {
        toast.success('profile updated');
        closeModal();
        reload();
      }
    } catch (error: any) {
      console.log(error);
      const { errors } = error.response.data;
      errors.map((err: { error: string }) => {
        return toast.error(err.error);
      });
      console.log(error);
    }
    setLoading(false);
  };

  const onSubmit = (data: any) => {
    const requestData: any = {};

    const keys = Object.keys(dirtyFields);
    for (const field of keys) {
      const value = data[field as keyof typeof data];
      requestData[field] = getNumbers(value);
    }

    updateUserFunction(requestData);
  };

  return (
    <ModalComp toggleModal={closeModal}>
      <div className="p-5 md:p-10">
        <h3 className="text-xl font-semibold">{selectedUser?.fullName}</h3>
        <br />
        <form className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {fields.map((field, index) => (
            <label className="space-y-2" key={index}>
              <div className="flex items-center space-x-2">
                <p className="font-bold capitalize">{field.label}</p>
              </div>
              <NumberInput
                {...field}
                decimalScale={5}
                required
                control={control}
                prefix="$"
              />
            </label>
          ))}
          <Button
            className="ml-auto rounded-md bg-blue-500 px-3 py-2 text-white md:col-span-3"
            disabled={!isDirty || !isValid || loading}
            loading={loading}
            onClick={handleSubmit(onSubmit)}
          >
            update
          </Button>
        </form>
      </div>
    </ModalComp>
  );
};

export default AccountModal;
